import React, { useEffect, useState } from "react";
import dummyProfileImg from "../../../../../assets/images/icon/dummyProfileImg.png";
import starImg from "../../../../../assets/images/icon/starImg.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  globalConstants,
  roles,
  translationConstants,
} from "../../../../../constants";
import {
  centerInstructorsActions,
  centerListingActions,
  instructorActions,
} from "../../../../../redux/actions";
import InstructorDetail from "../../../../../shared/components/InstructorDetail";
import InfiniteScroll from "react-infinite-scroll-component";
import InstructorCard from "../../../../../shared/components/ViewCenterCard/InstructorCard";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../../shared/utilitiies";
import DeleteModal from "../../../../../shared/components/Modals/DeleteModal";
import CustomModal from "../../../../../shared/components/CustomModal/CustomModal";

const InstructorsTab = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const defaultQueryExpression = "InstructorId != null ";

  //-------initial gridstate
  const initialGridState = {
    length: 7,
    search: null,
    pageNumber: 1,
    orderBy: "InstructorId desc",
    filterQuery: defaultQueryExpression,
  };

  const [gridState, setGridState] = useState(initialGridState);
  const [instructorsArray, setInstructorsArray] = useState([]);
  const [isViewDetail, setIsViewDetail] = useState(null);
  const [instructorData, setInstructorData] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  //-------reducers
  const centerListingReducer = useSelector(
    (state) => state.centerListingReducer
  );
  const role = useSelector((state) => state.LoginReducer?.UserData?.user?.role);
  //-------destructure reducers
  const { centerInstructors } = centerListingReducer;

  //-------Center Listing
  const { pageData } = centerInstructors;

  //-------Get More Centers List on Scroll
  const getMoreCenterInstructors = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  const onDelete = () => {
    dispatch(
      centerInstructorsActions.removeCenterInstructorByAdmin(
        props?.centerId,
        instructorData?.instructorId,
        () => {
          setShowDelete(false);
          dispatch(
            centerListingActions.getAllCenterInstructors(gridState, props?.centerId)
          );
          setIsViewDetail(false);
        }
      )
    );
  };

  //-------UseEffects
  useEffect(() => {
    dispatch(
      centerListingActions.getAllCenterInstructors(gridState, props.centerId)
    );
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setInstructorsArray(pageData);

    // eslint-disable-next-line
  }, [pageData]);
  return (
    <>
      <div className="row mx-md-4 mx-2 instructors-cards-wrapper">
        {isViewDetail ? (
          <InstructorDetail
            instructorData={instructorData}
            isGuestUser={false}
            centerId={props.centerId}
            setShowDelete={setShowDelete}
            isShowRemoveButton={
              role === roles.Admin || role === roles.SuperAdmin
            }
            onDelete={() => setShowDelete(true)}
          />
        ) : (
          <InfiniteScroll
            dataLength={instructorsArray?.length ?? 0}
            next={getMoreCenterInstructors}
            hasMore={
              instructorsArray?.length % 7 === 0 &&
              instructorsArray?.length !== 0
                ? true
                : false
            }
            loader={loadingIndicator(t)}
            endMessage={dataEndMessage(t, instructorsArray)}
            style={{ overflow: "hidden" }}
            scrollableTarget={"main-container"}
          >
            <div className="row m-0 w-100">
              {instructorsArray?.map((instructor) => {
                return (
                  <InstructorCard
                    instructor={instructor}
                    gridState={gridState}
                    centerId={props.centerId}
                    setInstructorData={setInstructorData}
                    setIsViewDetail={setIsViewDetail}
                    setShowDelete={setShowDelete}
                    isShowRemoveButton={
                      role === roles.Admin || role === roles.SuperAdmin
                    }
                  />
                );
              })}
            </div>
          </InfiniteScroll>
        )}
      </div>
      {showDelete && (
        <CustomModal
          scrollable={true}
          size="md"
          setShow={setShowDelete}
          show={showDelete}
          customClass="view-user-modal"
        >
          <DeleteModal
            title={t(translationConstants.REMOVE_INSTRUCTOR)}
            message={`${t(translationConstants.ARE_YOU_SURE_TO_REMOVE)} ${
              instructorData?.name
            }`}
            dataToDelete={instructorData}
            removeRowData={onDelete}
            onCancel={() => setShowDelete(false)}
          />
        </CustomModal>
      )}
    </>
  );
};

export default InstructorsTab;
